import type { ComponentType } from 'react';
import { Button } from 'react-bootstrap';
import { LINKS } from '../../app/appConstants';
import { BinIcon as BinIconBase } from '../../components/Icon/Icon.jsx';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext.js';
import {
    HelpContactPanelStyled,
    HelpDocItemStyled,
    HelpDocListStyled,
    HelpPageStyled,
    HelpSectionStyled,
} from './styled/HelpStyled';

const SUPPORT_EMAIL = 'support@affilers.com';

const DOC_KEYS = [
    { key: 'affiliate_agreement', href: LINKS.affiliateAgreementDoc },
    { key: 'communications_policy', href: LINKS.communicationsPolicyFxDoc },
    { key: 'privacy_policy', href: LINKS.privacyPolicyDoc },
] as const;

const BinIcon = BinIconBase as ComponentType<{ name: string; size?: string }>;

function Help() {
    const { getLangPath } = useLangContext();

    return (
        <HelpPageStyled>
            <div className="page-header">
                <span className="section-eyebrow">{getLangPath('help.eyebrow')}</span>
                <h1 className="page-title">{getLangPath('help.title')}</h1>
                <p className="page-desc">{getLangPath('help.desc')}</p>
            </div>

            <HelpSectionStyled>
                <div className="section-header">
                    <div className="section-heading">
                        <span className="section-eyebrow">{getLangPath('help.docs_step')}</span>
                        <h2 className="section-title">{getLangPath('help.docs_title')}</h2>
                        <p className="section-desc">{getLangPath('help.docs_desc')}</p>
                    </div>
                </div>

                <HelpDocListStyled>
                    {DOC_KEYS.map(({ key, href }) => (
                        <HelpDocItemStyled key={key}>
                            <a href={href} target="_blank" rel="noreferrer">
                                <p className="doc-title">{getLangPath(`help.docs.${key}`)}</p>
                                <span className="doc-meta">
                                    {getLangPath('help.open_pdf')}
                                    <BinIcon name="IcShareArrow" size="16px" />
                                </span>
                            </a>
                        </HelpDocItemStyled>
                    ))}
                </HelpDocListStyled>
            </HelpSectionStyled>

            <HelpSectionStyled>
                <div className="section-header">
                    <div className="section-heading">
                        <span className="section-eyebrow">{getLangPath('help.support_step')}</span>
                        <h2 className="section-title">{getLangPath('help.support_title')}</h2>
                        <p className="section-desc">{getLangPath('help.support_desc')}</p>
                    </div>
                </div>

                <HelpContactPanelStyled>
                    <p className="contact-label">{getLangPath('help.contact_label')}</p>
                    <h3 className="contact-title">{SUPPORT_EMAIL}</h3>
                    <p className="contact-desc">{getLangPath('help.contact_desc')}</p>
                    <div className="contact-actions">
                        <Button variant="primary" href={`mailto:${SUPPORT_EMAIL}`}>
                            {getLangPath('help.contact_cta')}
                            <BinIcon name="IcShareArrow" size="16px" />
                        </Button>
                    </div>
                </HelpContactPanelStyled>
            </HelpSectionStyled>
        </HelpPageStyled>
    );
}

export default Help;
